import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AlertLevel } from "@madmedical/medical";
import { Text } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Badge from "./Badge";
const StatusBadge = ({ level = AlertLevel.Ok, hasText = true, size = "sm", }) => {
    const { t } = useTranslation();
    const variants = useMemo(() => ({
        [AlertLevel.Ok]: {
            label: t("measures:ok"),
            variant: "ghostSuccess",
            icon: "checkmark",
            textColor: "green.600",
        },
        [AlertLevel.Warning]: {
            label: t("measures:warning"),
            variant: "ghostWarning",
            icon: "warning",
            textColor: "warning.600",
        },
        [AlertLevel.Alert]: {
            label: t("measures:alert"),
            variant: "ghostError",
            icon: "bullhorn",
            textColor: "error.500",
        },
    }), [t]);
    if (!level) {
        return null;
    }
    return (_jsx(Badge, Object.assign({ size: size, hasIndicator: false, leftIconName: variants[level].icon, variant: variants[level].variant, hasText: hasText }, { children: hasText && (_jsx(Text, Object.assign({ color: variants[level].textColor, fontSize: "xs" }, { children: variants[level].label }))) })));
};
export default StatusBadge;
